import { Routes, Route, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";
import { RegionProvider } from "./context/RegionContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Features from "./pages/Features";
import Pricing from "./pages/Pricing";
import Accounting from "./pages/Accounting";
import ExpenseTracker from "./pages/ExpenseTracker";
import WebsiteBuilder from "./pages/WebsiteBuilder";
import SocialMedia from "./pages/SocialMedia";
import POSSystem from "./pages/POSSystem";
import Payroll from "./pages/Payroll";
import MobileAccounting from "./pages/MobileAccounting";
import Security from "./pages/Security";
import Enterprise from "./pages/Enterprise";
import Careers from "./pages/Careers";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ScrollToTop from "./components/ScrollToTop";
import DesignSystem from "./pages/DesignSystem";
import Dashboard from "./pages/Dashboard";

// Detects Supabase auth tokens in the URL hash and redirects accordingly
function AuthRedirect() {
    const navigate = useNavigate();

    useEffect(() => {
        const hash = window.location.hash;
        if (hash && hash.includes("type=recovery")) {
            // Redirect to /reset-password, keeping the hash so Supabase can process the token
            navigate("/reset-password" + hash, { replace: true });
        }
    }, [navigate]);

    return null;
}

export default function App() {
    return (
        <RegionProvider>
            <Layout>
            <ScrollToTop />
            <AuthRedirect />
            <Routes>
                <Route path="/features" element={<Features />} />
                <Route path="/features/accounting" element={<Accounting />} />
                <Route path="/features/expenses" element={<ExpenseTracker />} />
                <Route path="/features/websites" element={<WebsiteBuilder />} />
                <Route path="/features/social" element={<SocialMedia />} />
                <Route path="/features/pos" element={<POSSystem />} />
                <Route path="/features/payroll" element={<Payroll />} />
                <Route path="/features/mobile-billing" element={<MobileAccounting />} />
                <Route path="/mobile-accounting" element={<MobileAccounting />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/palette" element={<DesignSystem />} />
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/security" element={<Security />} />
                <Route path="/enterprise" element={<Enterprise />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/signup" element={<Signup />} />
                <Route
                    path="/forgot-password"
                    element={
                        <AnimatePresence mode="wait">
                            <motion.div
                                initial={{ opacity: 0, y: 50, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: -50, scale: 0.95 }}
                                transition={{ duration: 0.6, ease: "easeInOut" }}
                            >
                                <ForgotPassword />
                            </motion.div>
                        </AnimatePresence>
                    }
                />
                <Route
                    path="/reset-password"
                    element={
                        <AnimatePresence mode="wait">
                            <motion.div
                                initial={{ opacity: 0, y: 50, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: -50, scale: 0.95 }}
                                transition={{ duration: 0.6, ease: "easeInOut" }}
                            >
                                <ResetPassword />
                            </motion.div>
                        </AnimatePresence>
                    }
                />
                <Route
                    path="/login"
                    element={
                        <AnimatePresence mode="wait">
                            <motion.div
                                initial={{ opacity: 0, y: 50, scale: 0.95 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: -50, scale: 0.95 }}
                                transition={{ duration: 0.6, ease: "easeInOut" }}
                            >
                                <Login />
                            </motion.div>
                        </AnimatePresence>
                    }
                />
            </Routes>
        </Layout>
    </RegionProvider>
    );
}
